/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingPackageQuotaOverride } from './BillingPackageQuotaOverride';
import {
    BillingPackageQuotaOverrideFromJSON,
    BillingPackageQuotaOverrideFromJSONTyped,
    BillingPackageQuotaOverrideToJSON,
    BillingPackageQuotaOverrideToJSONTyped,
} from './BillingPackageQuotaOverride';
import type { BillingProductPrice } from './BillingProductPrice';
import {
    BillingProductPriceFromJSON,
    BillingProductPriceFromJSONTyped,
    BillingProductPriceToJSON,
    BillingProductPriceToJSONTyped,
} from './BillingProductPrice';

/**
 * Represents a billing package and associated prices
 * @export
 * @interface BillingPackage
 */
export interface BillingPackage {
    /**
     * 
     * @type {number}
     * @memberof BillingPackage
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BillingPackage
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BillingPackage
     */
    interval: BillingPackageIntervalEnum;
    /**
     * How many trial days are given when signing up.
     * @type {number}
     * @memberof BillingPackage
     */
    trialPeriodDays: number;
    /**
     * Represents the package’s position in the pricing hierarchy.
     * @type {number}
     * @memberof BillingPackage
     */
    tier: number;
    /**
     * 
     * @type {boolean}
     * @memberof BillingPackage
     */
    allowsSignups: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BillingPackage
     */
    allowsSwitching: boolean;
    /**
     * 
     * @type {Array<BillingProductPrice>}
     * @memberof BillingPackage
     */
    billingProductPrices?: Array<BillingProductPrice>;
    /**
     * 
     * @type {Array<BillingPackageQuotaOverride>}
     * @memberof BillingPackage
     */
    billingPackageQuotaOverrides?: Array<BillingPackageQuotaOverride>;
}

/**
* @export
* @enum {string}
*/
export enum BillingPackageIntervalEnum {
    Annual = 'Annual',
    Monthly = 'Monthly'
}


/**
 * Check if a given object implements the BillingPackage interface.
 */
export function instanceOfBillingPackage(value: object): value is BillingPackage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('trialPeriodDays' in value) || value['trialPeriodDays'] === undefined) return false;
    if (!('tier' in value) || value['tier'] === undefined) return false;
    if (!('allowsSignups' in value) || value['allowsSignups'] === undefined) return false;
    if (!('allowsSwitching' in value) || value['allowsSwitching'] === undefined) return false;
    return true;
}

export function BillingPackageFromJSON(json: any): BillingPackage {
    return BillingPackageFromJSONTyped(json, false);
}

export function BillingPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'interval': json['interval'],
        'trialPeriodDays': json['trialPeriodDays'],
        'tier': json['tier'],
        'allowsSignups': json['allowsSignups'],
        'allowsSwitching': json['allowsSwitching'],
        'billingProductPrices': json['billingProductPrices'] == null ? undefined : ((json['billingProductPrices'] as Array<any>).map(BillingProductPriceFromJSON)),
        'billingPackageQuotaOverrides': json['billingPackageQuotaOverrides'] == null ? undefined : ((json['billingPackageQuotaOverrides'] as Array<any>).map(BillingPackageQuotaOverrideFromJSON)),
    };
}

  export function BillingPackageToJSON(json: any): BillingPackage {
      return BillingPackageToJSONTyped(json, false);
  }

  export function BillingPackageToJSONTyped(value?: BillingPackage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'interval': value['interval'],
        'trialPeriodDays': value['trialPeriodDays'],
        'tier': value['tier'],
        'allowsSignups': value['allowsSignups'],
        'allowsSwitching': value['allowsSwitching'],
        'billingProductPrices': value['billingProductPrices'] == null ? undefined : ((value['billingProductPrices'] as Array<any>).map(BillingProductPriceToJSON)),
        'billingPackageQuotaOverrides': value['billingPackageQuotaOverrides'] == null ? undefined : ((value['billingPackageQuotaOverrides'] as Array<any>).map(BillingPackageQuotaOverrideToJSON)),
    };
}

